import dayjs, { type Dayjs } from "dayjs";
import 'dayjs/locale/fr';

export class TimeUtils {

    static dateNow(): number {
        return Date.now();
    }

    static newDate(): Date {
        return new Date();
    }

    static getTime(): number {
        return new Date().getTime();
    }

    static getMoment(locale: string, dateMs: number): Dayjs {
        return dayjs(dateMs).locale(locale);
    }

    static extractTimestamp(dateString: string): number | null {
        const regex = /\/Date\((-?\d+)\)\//;
        if (typeof dateString !== 'string') {
            return null;
        }
        
        const match = dateString.match(regex);
        
        if (match && match[1]) {
            return parseInt(match[1], 10);
        } else {
            throw new Error(`Invalid date string format: ${dateString}`);
        }
    }

    super() {
        return this;
    }
}
